import * as React from "react";
import { css, keyframes, cx } from "emotion";
const animation = keyframes `
  0% {
    background-position: -650px 0;
  }
  100% {
    background-position: 650px 0;
  }
`;
const imageLoaderClass = css({
    animationDuration: "1.5s",
    animationFillMode: "forwards",
    animationIterationCount: "infinite",
    animationName: animation,
    animationTimingFunction: "linear",
    background: "#f6f7f8 linear-gradient(to right, #eeeeee 8%, #ccc 38%, #eeeeee 48%)",
    backgroundSize: "1300px 1300px",
    position: "relative",
});
const imageClass = css({
    opacity: 0,
    transition: "opacity .3s ease-in",
    position: "absolute",
});
const loadedClass = css({
    opacity: 1,
    position: "initial",
});
export class ReImage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loaded: false,
        };
    }
    componentDidMount() {
        const img = new Image();
        img.onload = () => {
            this.setState({ loaded: true });
        };
        img.src = this.props.src;
    }
    render() {
        const width = this.props.width || [100, "px"];
        const height = this.props.height || [100, "px"];
        const styles = {
            width: width.join(""),
            height: height.join(""),
        };
        const classes = [imageClass];
        this.state.loaded && classes.push(loadedClass);
        return (React.createElement(React.Fragment, null,
            React.createElement("img", { className: cx(classes), src: this.props.src }),
            !this.state.loaded && (React.createElement("div", { style: styles, className: cx(imageLoaderClass) }))));
    }
}
//# sourceMappingURL=reimage.js.map